import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { textareaClasses } from './styles.js';
import { useUiV2 } from './v2.js';
/**
 * 複数行入力 primitive。Input と同一の枠線/フォーカス/disabled スタイルを共有する。
 * 高さは rows 属性で制御し、preflight の `textarea { resize: vertical }` を踏襲する。
 */
export const Textarea = forwardRef(function Textarea({ invalid, size, fullWidth, v2, surface, className, ...rest }, ref) {
    const isV2 = useUiV2(v2);
    return (_jsx("textarea", { ref: ref, className: textareaClasses({ invalid, size, fullWidth, v2: isV2, surface, className }), ...rest }));
});
//# sourceMappingURL=Textarea.js.map